/**
 * Coin economy helpers. Standard: 1 coin = Rp1.000.
 * Use formatCoinsWithIDR() to display "X coins (≈ RpY.000)" anywhere.
 */
export const COIN_TO_IDR = 1000;

export const formatNumber = (n) => new Intl.NumberFormat('id-ID').format(Math.max(0, Math.floor(Number(n) || 0)));

export const formatIDR = (n) =>
  new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(Math.max(0, Math.floor(Number(n) || 0)));

/** "12 Coin (≈ Rp12.000)" */
export const formatCoinsWithIDR = (coins) => {
  const c = Math.max(0, Math.floor(Number(coins) || 0));
  return `${formatNumber(c)} Coin (≈ ${formatIDR(c * COIN_TO_IDR)})`;
};

/** "≈ Rp12.000" — for subtle inline tag */
export const formatIDRForCoins = (coins) => {
  const c = Math.max(0, Math.floor(Number(coins) || 0));
  return `≈ ${formatIDR(c * COIN_TO_IDR)}`;
};

/** Convert IDR amount to coins (floor). */
export const idrToCoins = (idr) => Math.max(0, Math.floor(Number(idr) || 0) / COIN_TO_IDR);
